import React from 'react';
import { GameWrapper } from '@views/GameWrapper';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <GameWrapper />
    </QueryClientProvider>
  );
};
